import { $list } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'
import { isEnterKey } from 'src/scripts/utils/key'

const ADDRESS_DELETE_BUTTON_SELECTOR = '[data-addresses-delete-button]'

const postLink = function (path, options) {
  options = options || {}

  const method = options['method'] || 'post'
  const params = options['parameters'] || {}

  const form = document.createElement('form')

  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (let key in params) {
    let hiddenField = document.createElement('input')

    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])

    form.appendChild(hiddenField)
  }

  document.body.appendChild(form)

  form.submit()

  document.body.removeChild(form)
}

export class AddressesComponent extends BaseComponent {
  mountComponent(): void {
    const deleteButtons = $list(ADDRESS_DELETE_BUTTON_SELECTOR, this)

    deleteButtons.forEach(element => {
      this.addListener(element, 'click', this.handleDeleteButtonClick)
    })

    this.addListener(this, 'keydown', this.handleKeydown)
  }

  handleKeydown = (event: KeyboardEvent) => {
    const target = event.target as HTMLInputElement
    const isCheckbox = target.getAttribute('type') === 'checkbox'

    if (isCheckbox && isEnterKey(event)) {
      event.preventDefault()
      target.checked = !target.checked
    }
  }

  handleDeleteButtonClick = ({ currentTarget }): void => {
    const text = currentTarget.getAttribute('data-confirm-message')
    const isConfirm = confirm(text)

    if (isConfirm) {
      postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      })
    }
  }
}
